export const contentCarouselLandingPage: {
    text: string;

    imageUrl: string;
}[] = [
    {
        text: "Autos usados en Bogotá con historial certificado.",
        imageUrl: "/assets/landing/car.svg",
    },
    {
        text: "Vehículos exclusivos con peritaje detallado publicado online.",
        imageUrl: "/assets/landing/computer.svg",
    },
    {
        text: "Garantía premium de satisfacción y cobertura mecánica.",
        imageUrl: "/assets/landing/star.svg",
    },
    {
        text: "Compra sin letra pequeña: trámites incluidos y entrega inmediata.",
        imageUrl: "/assets/landing/money.svg",
    },
];

export const contentCarousel2LandingPage: {
    text: string;
    textOrange: string;
    imageUrl: string;
}[] = [
    {
        text: "Proceso ágil, transparente y",
        textOrange: " directo",
        imageUrl: "/assets/landing/tech.svg",
    },
    {
        text: "Garantía de 6 meses que",
        textOrange: "respalda tu compra",
        imageUrl: "/assets/landing/check-circle.svg",
    },
    {
        text: "Precios claros,",
        textOrange: "sin sorpresas",
        imageUrl: "/assets/landing/money-2.svg",
    },
];
